module.exports = __webpack_public_path__ + "files/1cc2f3c5d657a2e01d546a993e7cebfa.png";